/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Paper,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Modal,
  Fade,
  Backdrop,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import { Info, Edit, OpenInNew } from "@material-ui/icons";
import { MdContentCopy } from "react-icons/md";
import ClaimCard from "./ClaimCard";
import votBox from "../../assets/votBox.png";
import lafLogo from "../../assets/lafLogo.png";
import { ethers } from "ethers";
import { useStylesDark, useStylesLight } from "../../Styles/ClaimPageStyles";
import { tokenOptions } from "../Auction/tokenOptions";
import { ref, onValue } from "firebase/database";
import {
  merkleAddressEthereum,
  merkleABI,
  addressRegistryABI,
  addressRegistryAddress,
  vlCVXAddress,
  vlCVXABI,
  depositAddressEthereum,
  depositABI,
  NETWORKS,
} from "../../constants";
import cvxLogo from "../../assets/cvxLogo.png";
import { BsFillLightningFill } from "react-icons/bs";
import VoteCalculator from "../Auction/Components/VoteCalculator";
import { delegationStatus } from "../../scripts/scripts";
import OptOutSection from "./OptOutSection";

var _ = require("lodash");

const UNION_ADDRESS = "0xcc2a0f5e95c88aabd7b8e0db5c5252820cd47f91";
const UNION_MANAGE_URL = "https://llama.airforce/union/member";
// AddressRegistry stores this as the expiration of a registration that has
// not been set to expire.
const NO_EXPIRATION = 0xfffffffff;

// Registry and vlCVX live on mainnet; reading through the wallet fails when
// it is connected to another chain.
const readProvider = new ethers.providers.JsonRpcProvider(
  NETWORKS.mainnet.rpcUrl
);

const specialColorDark = {
  style: { color: "rgb(232, 230, 227)" }, // Set the color of the text input in the TextField to white (#fff)
};

const AccountDetails = (props) => {
  const classesLight = useStylesLight();
  const classesDark = useStylesDark();
  const [classes, setClasses] = useState(classesDark);
  const [unconsumedDeposits, setUnconsumedDeposits] = useState(false);
  const [lockedAmount, setLockedAmount] = useState("0");
  const [openForwardingModal, setOpenForwardingModal] = useState(false);
  const [delegateText, setDelegateText] = useState("Connect to Ethereum");
  const [connectedNetwork, setConnectedNetwork] = useState(0);
  const [forwardAddress, setForwardAdress] = useState("");
  const [disableCancel, setDisableCancel] = useState(true);
  const [disableForward, setDisableForward] = useState(true);
  const [forwardedToText, setForwardedToText] = useState("Loading...");
  const [bothDisabledText, setBothDisabledText] = useState("");
  // Keep VoteCalculator mounted while its dialog is open so a mid-flow
  // refreshDelegation cannot unmount it when status flips to "Votium" (C1).
  const [setupDialogOpen, setSetupDialogOpen] = useState(false);
  // Delegation status is read live from chain (App.js -> getDelegateAddress).
  const {
    loading: delegationLoading,
    isVotiumCurrent,
    isVotiumFull,
    isVotiumPendingOnly,
  } = delegationStatus(props.delegateAddress);
  const delegationText = delegationLoading
    ? "..."
    : isVotiumFull
      ? "Votium"
      : isVotiumPendingOnly
        ? "Votium (starts next round)"
        : isVotiumCurrent
          ? "Votium (ends next round)"
          : "Not Delegated to Votium";

  const createData = (title, info, id) => {
    return { title, info, id };
  };
  const [rows, setRows] = useState([
    createData("Locked CVX Amount", "Loading...", 0), //make line an accordion which expands to show expiry date etc.
    createData(
      <>
        Delegation Status{" "}
        <Tooltip
          title="To be eligible for the rewards, you have to be locked and delegated
                before the Convex gauge vote proposal started.
                Votium will try to vote for incentives optimally, 
                giving vlCVX holders the best returns. 
                Delegating to Votium is not mandatory.
                You can vote for yourself to receive incentives."
        >
          <Info className={classes.infoIcon} />
        </Tooltip>
      </>,
      "Not Delegated to Votium",
      1
    ),
    createData(
      <>
        Current Forwarding{" "}
        <Tooltip
          title="Address Forwarding is a feature that allows you to forward future Votium rewards to be claimed by a different address/contract (e.g. The Union).
        All changes to address registrations have a one round waiting period before taking effect. When canceling an active registration, you will not be able to register a new forwarding address until the following round, meaning there will be one round with no forwarding."
        >
          <Info className={classes.infoIcon} />
        </Tooltip>
      </>,
      "The Union",
      2
    ),
    // createData("Current Vote", "ETH-USDC (0x42..21)", 3), //hide line if delegated.
    createData("Votes History"), // make accordion
  ]);

  // check provider network
  useEffect(() => {
    if (props.provider !== undefined) {
      if (props.provider._network !== undefined) {
        setConnectedNetwork(props.provider._network.chainId);
        if (props.provider._network.chainId !== 1) {
          setDelegateText("Connect to Ethereum");
        } else {
          setDelegateText("Delegate");
        }
      } else if (connectedNetwork > -100) {
        setTimeout(() => {
          setConnectedNetwork(connectedNetwork - 1);
        }, 100);
      }
    }
  }, [props.provider, connectedNetwork]);

  //check if user is delegated
  // Removed: DB-based isDelegated check. isDelegated is now derived from
  // props.delegateAddress (live contract read owned by App.js).

  //fetch amount of vlCVX for an address
  const getvlCVX = async (address, isStale = () => false) => {
    try {
      const vlCVXContract = new ethers.Contract(
        vlCVXAddress,
        vlCVXABI,
        readProvider
      );
      const balance = await vlCVXContract.balanceOf(address);
      if (isStale()) return;
      let numFloat = parseFloat(ethers.utils.formatEther(balance));
      let formattedAmount = numFloat.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      setLockedAmount(formattedAmount);
    } catch (e) {
      console.log("Couldn't load vlCVX balance", e);
    }
  };

  //check if address already forwarded
  const checkForward = async (address, isStale = () => false) => {
    try {
      const addressRegistryContract = new ethers.Contract(
        addressRegistryAddress,
        addressRegistryABI,
        readProvider
      );
      const res = await addressRegistryContract.registry(address);
      if (isStale()) return;

      const now = Math.floor(Date.now() / 1000);
      const start = res.start.toNumber();
      const expiration = res.expiration.toNumber();

      if (start !== 0 && expiration > now) {
        setForwardedToText(
          res.to.toLowerCase() === UNION_ADDRESS
            ? "The Union"
            : res.to.substring(0, 4) +
                "..." +
                res.to.substring(res.to.length - 2, res.to.length)
        );
        if (expiration < NO_EXPIRATION) {
          setDisableCancel(true);
          setDisableForward(true);
          setBothDisabledText(
            "Registration is already set to expire. Must wait until next round before making changes."
          );
        } else {
          setDisableCancel(false);
          setDisableForward(true);
          setBothDisabledText("");
        }
      } else {
        setForwardedToText("N/A");
        setDisableCancel(true);
        setDisableForward(false);
        setBothDisabledText("");
      }
    } catch (e) {
      if (isStale()) return;
      console.log("Couldn't load forwarding status", e);
      setForwardedToText("Unable to load");
      setDisableCancel(true);
      setDisableForward(true);
      setBothDisabledText("");
    }
  };

  // Keyed on address only: App recreates `provider` on every render.
  useEffect(() => {
    if (!props.address) return;
    let stale = false;
    const isStale = () => stale;
    setForwardedToText("Loading...");
    setDisableCancel(true);
    setDisableForward(true);
    setBothDisabledText("");
    setLockedAmount("0");
    checkForward(props.address, isStale);
    getvlCVX(props.address, isStale);
    return () => {
      stale = true;
    };
  }, [props.address]);

  //check if user has unconsumed deposits
  useEffect(() => {
    //fetch userDeposits from db
  }, [props.provider, props.address, props.db]);

  //populate table
  useEffect(() => {
    const row0 = createData("Locked CVX Amount", lockedAmount, 0); //make line an accordion which expands to show expiry date etc.
    const row1 = createData(
      <>
        Delegation Status{" "}
        <Tooltip
          title="To be eligible for the rewards, you have to be locked and delegated
                before the Convex gauge vote proposal started.
                Votium will try to vote for incentives optimally, 
                giving vlCVX holders the best returns. 
                Delegating to Votium is not mandatory.
                You can vote for yourself to receive incentives."
        >
          <Info className={classes.infoIcon} />
        </Tooltip>
      </>,
      delegationText,
      1
    );
    const row2 = createData(
      <>
        Forwarding Status{" "}
        <Tooltip
          title="Address Forwarding is a feature that allows you to forward future Votium rewards to be claimed by a different address/contract (e.g. The Union).
        All changes to address registrations have a one round waiting period before taking effect. When canceling an active registration, you will not be able to register a new forwarding address until the following round, meaning there will be one round with no forwarding."
        >
          <Info className={classes.infoIcon} />
        </Tooltip>
      </>,
      forwardedToText + " ",
      2
    );
    // const row3 = createData(
    //   "Current Vote",
    //   "ETH-USDC (0x42..21)",
    //   3
    // ); //hide line if delegated.
    const row4 = createData("Votes History"); // make accordion
    // if (isDelegated) {
    //   array = array.filter((item) => item !== row3);
    // }

    let array = [row0, row1, row2, row4];
    setRows(array);
  }, [lockedAmount, forwardedToText, delegationText]);

  // theme setting
  useEffect(() => {
    if (props.ctheme === "light") {
      setClasses(classesLight);
    } else {
      setClasses(classesDark);
    }
  }, [props.ctheme]);

  const handleOpenForwardingModal = () => {
    setOpenForwardingModal(true);
  };
  const handleCloseForwardingModal = () => {
    setOpenForwardingModal(false);
  };

  const handleForward = async () => {
    const signer = props.provider.getSigner();
    const addressRegistryContract = new ethers.Contract(
      addressRegistryAddress,
      addressRegistryABI,
      signer
    );
    try {
      const tx = await addressRegistryContract.setRegistry(forwardAddress);
      await tx.wait();
      checkForward(props.address);
    } catch {
      console.log("Couldn't forward");
    }
  };
  const handleCancel = async () => {
    const signer = props.provider.getSigner();
    const addressRegistryContract = new ethers.Contract(
      addressRegistryAddress,
      addressRegistryABI,
      signer
    );
    try {
      const tx = await addressRegistryContract.setToExpire();
      await tx.wait();
      checkForward(props.address);
    } catch {
      console.log("Couldn't cancel");
    }
  };

  const handleCopyClick = (value) => setForwardAdress(value);

  return (
    connectedNetwork !== 0 && (
      <>
        <Paper className={classes.accountDetailsCard}>
          {" "}
          <Grid container direction="column" alignItems="center">
            <Typography className={classes.noActiveAuctionTitle}>
              Your Votium information
            </Typography>{" "}
            {unconsumedDeposits && (
              <Typography className={classes.unconsumedDepositsText}>
                You have unconsumed deposits to withdraw: {"<click here>"}
              </Typography>
            )}
            <TableContainer className={classes.infoTable}>
              <Table className={classes.table}>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow key={row.id ?? "votes-history"}>
                      <TableCell
                        component="th"
                        scope="row"
                        style={{ borderBlockColor: "grey" }}
                      >
                        <Typography className={classes.tableText}>
                          {" "}
                          {row.title}
                        </Typography>
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{ borderBlockColor: "grey" }}
                      >
                        <Typography
                          component="div"
                          className={
                            row.id === 1
                              ? `${classes.tableSubText} ${classes.delegationStatusInfo}`
                              : classes.tableSubText
                          }
                        >
                          {row.info === "The Union " && (
                            <>
                              <img
                                className={classes.icon}
                                alt="icon"
                                src={lafLogo}
                              ></img>
                            </>
                          )}
                          {row.info === "Votium" && (
                            <>
                              <img
                                className={classes.icon}
                                alt="icon"
                                src={votBox}
                              ></img>
                            </>
                          )}
                          {row.id === 0 && (
                            <img
                              src={cvxLogo}
                              alt="cvx-logo"
                              className={classes.icon}
                            ></img>
                          )}
                          {row.info}
                          {row.id === 0 && (
                            <OpenInNew
                              onClick={() => {
                                window.open(
                                  "https://www.convexfinance.com/lock-cvx",
                                  "_blank"
                                );
                              }}
                              className={classes.editButton}
                            />
                          )}
                          {row.id === 1 && (
                            <>
                              {(row.info !== "Votium" || setupDialogOpen) && (
                                <>
                                  <VoteCalculator
                                    setupOnly
                                    hideTrigger={row.info === "Votium"}
                                    onOpenChange={setSetupDialogOpen}
                                    triggerLabel="Delegate"
                                    triggerClasses={{
                                      root: classes.delegateButton,
                                      disabled: classes.delegateButtonDisabled,
                                    }}
                                    triggerDisabled={
                                      delegateText === "Connect to Ethereum"
                                    }
                                    triggerDisableRipple
                                    ctheme={props.ctheme}
                                    delegateAddress={props.delegateAddress}
                                    forwardingAddress={
                                      forwardedToText === "The Union"
                                        ? UNION_ADDRESS
                                        : undefined
                                    }
                                    provider={props.provider}
                                    address={props.address}
                                    refreshDelegation={props.refreshDelegation}
                                    connect={props.connect}
                                    bribesArray={[]}
                                  />
                                </>
                              )}
                            </>
                          )}
                          {row.id === 2 && (
                            <>
                              <Edit
                                onClick={handleOpenForwardingModal}
                                className={classes.editButton}
                              />
                              <Modal
                                className={classes.forwardModal}
                                open={openForwardingModal}
                                onClose={handleCloseForwardingModal}
                                closeAfterTransition
                                BackdropComponent={Backdrop}
                                BackdropProps={{
                                  timeout: 500,
                                }}
                              >
                                <Fade in={openForwardingModal}>
                                  <div className={classes.forwardModalPaper}>
                                    <Grid
                                      container
                                      direction="column"
                                      alignItems="center"
                                    >
                                      {bothDisabledText === "" && (
                                        <Grid
                                          container
                                          justifyContent="center"
                                        >
                                        <Grid item>
                                          <Typography
                                            className={classes.modalText}
                                          >
                                            <p>
                                              {" "}
                                              The following transaction will let
                                              you forward your future rewards to
                                              be claimable by another
                                              contract/address.
                                            </p>
                                            <p>
                                              {
                                                "You can choose to forward your rewards to The Union (0xcc...91)"
                                              }
                                              <Button
                                                onClick={() => {
                                                  handleCopyClick(
                                                    "0xcc2a0f5e95c88aabd7b8e0db5c5252820cd47f91"
                                                  );
                                                }}
                                                disableElevation
                                                className={classes.copyButton}
                                              >
                                                <MdContentCopy></MdContentCopy>
                                              </Button>
                                              <a href="https://llama.airforce/#/union/member">
                                                (What's This?)
                                              </a>
                                            </p>
                                          </Typography>
                                        </Grid>
                                        <Grid item>
                                          <TextField
                                            className={classes.modalInput}
                                            label={"Recepient Address"}
                                            color="secondary"
                                            variant="outlined"
                                            value={forwardAddress}
                                            onChange={(e) => {
                                              setForwardAdress(e.target.value);
                                            }}
                                            inputProps={specialColorDark}
                                            InputLabelProps={specialColorDark}
                                            FormHelperTextProps={specialColorDark}
                                          ></TextField>
                                        </Grid>
                                        <Grid
                                          container
                                          direction="row"
                                          justifyContent="center"
                                        >
                                          <Grid item>
                                            <Button
                                              classes={{
                                                root: classes.modalDelegateButton,
                                                disabled:
                                                  classes.modalDelegateButtonDisabled,
                                              }}
                                              disableRipple
                                              onClick={handleCancel}
                                              disabled={
                                                disableCancel ||
                                                connectedNetwork !== 1
                                              }
                                            >
                                              Cancel existing forwarding
                                            </Button>
                                          </Grid>
                                          <Grid item>
                                            <Button
                                              classes={{
                                                root: classes.modalDelegateButton,
                                                disabled:
                                                  classes.modalDelegateButtonDisabled,
                                              }}
                                              disableRipple
                                              onClick={handleForward}
                                              disabled={
                                                disableForward ||
                                                connectedNetwork !== 1
                                              }
                                            >
                                              {forwardAddress ===
                                              "0x0000000000000000000000000000000000000000"
                                                ? "Do not forward to 0x0 address"
                                                : "Confirm new address"}
                                            </Button>
                                          </Grid>
                                        </Grid>
                                        </Grid>
                                      )}
                                      {forwardedToText !== "" && (
                                        <Grid item>
                                          <Typography className={classes.modalText}>
                                            {"Currently forwarded to: " +
                                              forwardedToText}
                                          </Typography>
                                        </Grid>
                                      )}
                                      {bothDisabledText !== "" && (
                                        <Grid item>
                                          <Typography className={classes.modalText}>
                                            {bothDisabledText}
                                          </Typography>
                                        </Grid>
                                      )}
                                      {connectedNetwork !== 1 && (
                                        <Grid item>
                                          <Typography className={classes.modalText}>
                                            Connect to Ethereum to change your
                                            forwarding.
                                          </Typography>
                                        </Grid>
                                      )}
                                    </Grid>
                                  </div>
                                </Fade>
                              </Modal>
                            </>
                          )}
                          {row.id === 3 && (
                            <BsFillLightningFill
                              onClick={() => {
                                console.log("Edit Button");
                              }}
                              className={classes.snapshotIcon}
                            />
                          )}
                          {row.id === undefined && (
                            <OpenInNew
                              onClick={() => {
                                window.open(
                                  "https://llama.airforce/#/bribes/rounds/votium/",
                                  "_blank"
                                );
                              }}
                              className={classes.editButton}
                            />
                          )}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ borderBlockColor: "grey" }}
                    >
                      <Typography className={classes.tableText}>
                        Reward Opt-Out{" "}
                        <Tooltip title="Opt out of receiving Votium rewards for your votes on selected Curve or f(x) gauges. Changes take effect the following vlCVX epoch. If you opt back in during an active vote, you remain opted out of those gauges until this epoch ends.">
                          <Info className={classes.infoIcon} />
                        </Tooltip>
                      </Typography>
                    </TableCell>
                    <TableCell
                      align="right"
                      style={{ borderBlockColor: "grey" }}
                    >
                      <OptOutSection
                        address={props.address}
                        provider={props.provider}
                        db={props.db}
                        classes={classes}
                        connectedNetwork={connectedNetwork}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            {forwardedToText === "The Union" && (
              <Grid item align="center">
                <Button
                  className={classes.unionManageButton}
                  onClick={() => window.open(UNION_MANAGE_URL, "_blank")}
                  variant="contained"
                >
                  Manage Rewards on The Union
                </Button>
              </Grid>
            )}
            <Grid item align="center">
              <Button
                className={classes.faqButton}
                onClick={() => {
                  window.open("https://docs.votium.app/faq/vlcvx-faq");
                }}
                variant="outlined"
              >
                Frequently Asked Questions
              </Button>
            </Grid>
            <Grid container direction="row" justifyContent="center">
              <Grid item>
                <img
                  src={votBox}
                  alt="time-icon"
                  className={classes.votBox}
                ></img>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </>
    )
  );
};

export default AccountDetails;
